import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractInterface, FullClientInterface, ValidationInterface } from '../data';
import { UseCaseWithParam } from './common/use.case.with.params';
import { Transaction } from '../transaction/transaction';
import { ValidationProvider } from '../providers/validation.provider';

export interface UpdateValidationUseCaseParams {
    contract?: ContractInterface;
    client?: FullClientInterface;
}

@Injectable()
export class UpdateValidationUseCase implements UseCaseWithParam<UpdateValidationUseCaseParams, Observable<Transaction<void>>> {
    constructor(private validationProvider: ValidationProvider) {}

    bind(params: UpdateValidationUseCaseParams): Observable<Transaction<void>> {
        return of(true).pipe(
            switchMap(() => {
                const validation: ValidationInterface = params.contract
                    ? params.contract.validation
                    : params.client
                    ? params.client.validation
                    : null;

                if (validation) {
                    return this.validationProvider.update(validation);
                }

                return of(Transaction.error<void>());
            })
        );
    }
}
